module.exports = __webpack_public_path__ + "media/images/symbols/twitter-9ef30187f3251e82691f8bfc188ce922.svg";